"use client"

import { useMemo } from "react"
import { twMerge } from "tailwind-merge"

import { generateResponsiveCSS } from "../../../lib/helper"
import { ServiceShowcaseContent } from "./components/ServiceShowcaseContent"
import type { ServiceShowcaseProps } from "./types/config"

export const RenderConfig = {
  render: ({
    defaultBackgroundImage,
    defaultTitle,
    sectionTitle,
    logo,
    buttonText,
    buttonLink,
    defaultDescription,
    services,
    slidesPerView,
    spaceBetween,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: ServiceShowcaseProps & { id?: string }) => {
    const id = useMemo(
      () => componentId || `service-showcase-${Math.random().toString(36).substr(2, 9)}`,
      [componentId]
    )
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div className={twMerge(className)} id={id}>
          <ServiceShowcaseContent
            id={id}
            defaultBackgroundImage={defaultBackgroundImage}
            defaultTitle={defaultTitle}
            defaultDescription={defaultDescription}
            sectionTitle={sectionTitle}
            logo={logo}
            buttonText={buttonText}
            buttonLink={buttonLink}
            services={services}
            slidesPerView={slidesPerView}
            spaceBetween={spaceBetween}
            className=""
          />
        </div>
      </>
    )
  },
}

